import {
  GlobalConfigType,
  setApplicationStep,
  setBorrowerAllData,
  setBorrowerGroupData,
  setLoanAllData,
  setLoanDetail,
  setLoanLtvMaxLimit,
  setOverviewStep,
} from 'actions'
import cloneDeep from 'clone-deep'
import { AccountType, SettingKey } from 'config'
import { isCustomOrigin } from 'config/loan.input.visibility.type'
import { additionalMemberValidate } from 'pages/LoanApplication/AdditionalMember/logic'
import { assetInfoValidate } from 'pages/LoanApplication/AssetInformation/logics'
import { borrowerInfoValidate } from 'pages/LoanApplication/BorrowerInformation/logic'
import { BorrowerSeperator } from 'pages/LoanApplication/config'
import { creditValidate } from 'pages/LoanApplication/CreditScore/logic'
import { customInformationValidate } from 'pages/LoanApplication/CustomInformation/logic'
import { declarationsHmdaValidate } from 'pages/LoanApplication/DeclarationsHmda/logic'
import { signMldsValidate } from 'pages/LoanApplication/MLDS/logic'
import { propertyInfoValidate } from 'pages/LoanApplication/PropertyInformation/logic'
import { signAppValidate } from 'pages/LoanApplication/SignApplication/logic'
import { trackRecordValidate } from 'pages/LoanApplication/TrackRecord/logic'
import { borrowerMenuKey } from 'pages/LoanApplication/util'
import { getLockExpired, validateLoanStructureData } from 'pages/LoanStructure/Logic'
import { store } from 'reducers'
import { borrowerInitialState } from 'reducers/borrower.reducer'
import { getloanDetailInitialState, LoanType } from 'reducers/loanDetail.reducer'
import { stepInitialState } from 'reducers/step.reducer'
import Api from 'services/api'
import { getAdminConfig, getLoanOverview, isVendorEnabled } from 'services/apis'
import { formatDate } from 'utils'
import { setBorrowerDefaultData, setLoanDefaultData } from 'utils/loan'

const checkStatus = (data: any) => {
  let allPass = true
  Object.keys(data).map((key) => {
    if (data[key] === -1) allPass = false
  })
  return allPass
}

export const stepUpgradeWhenRestructureReleaseNoToYes = async () => {
  await store.dispatch(
    setBorrowerGroupData('borrower', {
      signedDate: '',
      agreeToSign: false,
    }),
  )
  const { step } = await store.getState()
  let overview = cloneDeep(step.overview)

  overview.application.detail.signApplication = 0
  if (overview.application.status === 1) {
    overview.application.status = 0
  }

  await store.dispatch(setOverviewStep(overview))

  let application = cloneDeep(step.application)
  application.sign = -1
  await store.dispatch(setApplicationStep(application))

  return true
}

export const loanOverviewAndStepLogic = async (
  loanNumber: string,
  menu: string,
): Promise<{ success: boolean; message?: string }> => {
  return new Promise(async (resolve) => {
    try {
      Api.setLoanNumber(loanNumber)
      let { overview, application } = stepInitialState()

      const { globalConfigReducer } = store.getState()
      let loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields]
      let globalSettingV2 = globalConfigReducer[GlobalConfigType.GlobalSettingV2]

      if (Object.keys(loanFieldProperties).length == 0)
        loanFieldProperties = await getAdminConfig('loanFieldProperties')

      if (loanNumber === 'new') {
        let [loanGlobalSettings, pricingEngine] = await Promise.all([
          getAdminConfig(SettingKey.GLOBAL_SETTINGS),
          isVendorEnabled('Rtltrader'),
        ])

        await store.dispatch(setOverviewStep(overview))
        await store.dispatch(setApplicationStep(application))

        let loanDetailData = getloanDetailInitialState()
        loanDetailData.loanNumber = 'New'
        loanDetailData.borrowerName = '-'
        loanDetailData.propertyAddress = '-'
        loanDetailData.loanGlobalSettings = loanGlobalSettings
        loanDetailData.pricingEngine = pricingEngine
        loanDetailData.loanStatus = globalSettingV2.defaultLoanStatus
        await store.dispatch(setLoanDetail(loanDetailData))

        const borrowerData = borrowerInitialState()
        await store.dispatch(setBorrowerAllData(setBorrowerDefaultData(borrowerData, loanFieldProperties)))
        await store.dispatch(setLoanAllData(setLoanDefaultData({}, loanFieldProperties)))
        await store.dispatch(setLoanLtvMaxLimit({}))
        return resolve({ success: true })
      }

      const res = await getLoanOverview()

      const loanData = res.loan
      await store.dispatch(setLoanAllData(setLoanDefaultData(loanData, loanFieldProperties)))
      await store.dispatch(setLoanLtvMaxLimit({}))

      let loanDetailData = getloanDetailInitialState()

      loanDetailData.loanNumber = loanData.no
      loanDetailData.byteproFileName = loanData.byteproFileName
      loanDetailData.entityTitle = res.entityTitle
      loanDetailData.borrowerName = res.borrowerNames
      loanDetailData.propertyAddress = loanData.subjectPropertyAddress
      loanDetailData.includeCoborrower = loanData.includeCoborrower
      loanDetailData.loanType = loanData.type
      loanDetailData.restructureApplicationRelease = res.process.restructureApplicationRelease
      loanDetailData.closingDate = res.process.closingDate
      loanDetailData.applicationDate = res.process.applicationDate
      loanDetailData.emailContacts = res.process.emailContacts
      loanDetailData.loanStatus = res.process.loanStatus
      loanDetailData.servicingStatus = res.process.servicingStatus
      loanDetailData.servicingPipeline = res.process.servicingPipeline
      loanDetailData.submitToAE = res.process.submitToAE
      loanDetailData.submitToLoanSetup = res.process.submitToLoanSetup
      loanDetailData.submitConditions = res.process.submitConditions
      loanDetailData.submitToUnderwriter = res.process.submitToUnderwriter
      loanDetailData.loanProcessDate = formatDate(res.process.loanProcessDate)
      loanDetailData.parties = res.parties
      loanDetailData.closeParties = res.closeParties
      loanDetailData.rateData = res.process.rateData
      loanDetailData.rush = res.process.rush
      loanDetailData.priceAdjustments = res.process.priceAdjustments
      loanDetailData.pushedToYieldeasyAt = res.process.pushedToYieldeasyAt
      // loanDetailData.crossCollateralBlanketLimit = res.assetTrack.crossCollateralLimit
      // loanDetailData.allocatedLoanAmount = res.assetTrack.allocatedLoanAmount
      loanDetailData.loanGlobalSettings = res.globalSetting
      loanDetailData.pricingEngine = res.pricingEngine
      loanDetailData.isCreatedByBorrower = res.isCreatedByBorrower
      loanDetailData.servicerLoanNumber = res.process.servicerLoanNumber
      loanDetailData.templateNumber = res.templateNumber
      loanDetailData.closingCostEstimate = res.closingCostEstimate
      loanDetailData.thirdPartyId = loanData.thirdPartyId
      loanDetailData.mers = res.mers
      loanDetailData.createdAt = res.createdAt

      await store.dispatch(setLoanDetail(loanDetailData))

      let borrowerData = res.borrower

      Object.keys(borrowerData).forEach((borrowerSep) => {
        borrowerData[borrowerSep] = {
          ...borrowerData[borrowerSep],
          assets: [],
          liabilities: [],
          tracks: [],
          rentalEstates: [],
          additionalPropertyInfo: [],
          earnestMoney: '',
          sellerCredit: '',
          otherCredit: '',
          purchaseCredits: {},
          additionalMembers: [],
        }

        if (!res.assetTrack[borrowerSep]) return
        ;[
          'assets',
          'liabilities',
          'tracks',
          'rentalEstates',
          'additionalPropertyInfo',
          'earnestMoney',
          'sellerCredit',
          'otherCredit',
          'purchaseCredits',
          'additionalMembers',
          'crossCollateralLimit',
          'allocatedLoanAmount',
        ].forEach((key) => {
          if (!res.assetTrack[borrowerSep][key]) return
          borrowerData[borrowerSep][key] = res.assetTrack[borrowerSep][key]
        })

        const filteredData = (res.assetTrack.borrower?.additionalMembers || []).filter(
          (item: any) =>
            item.borrowerSeperator === borrowerSep ||
            (borrowerSep === BorrowerSeperator.BORROWER && !item.borrowerSeperator),
        )
        if (borrowerSep === BorrowerSeperator.BORROWER) borrowerData[borrowerSep].additionalMembers = filteredData
        else
          borrowerData[borrowerSep].additionalMembers = [
            ...filteredData,
            ...borrowerData[borrowerSep].additionalMembers,
          ]
      })

      // borrowerData.borrower.assets = res.assetTrack.assets
      // borrowerData.borrower.liabilities = res.assetTrack.liabilities
      // borrowerData.borrower.tracks = res.assetTrack.tracks
      // borrowerData.borrower.rentalEstates = res.assetTrack.rentalEstates
      // // borrowerData.borrower.additionalMembers = res.assetTrack.additionalMembers
      // borrowerData.borrower.additionalPropertyInfo = res.assetTrack.additionalPropertyInfo
      // borrowerData.borrower.earnestMoney = res.assetTrack.earnestMoney
      // borrowerData.borrower.sellerCredit = res.assetTrack.sellerCredit
      // borrowerData.borrower.otherCredit = res.assetTrack.otherCredit
      // borrowerData.borrower.purchaseCredits = res.assetTrack.purchaseCredits
      // Object.keys(borrowerData).map((borrowerSeperator) => {
      //   const filteredData = res.assetTrack.additionalMembers.filter(
      //     (item: any) =>
      //       item.borrowerSeperator === borrowerSeperator ||
      //       (borrowerSeperator === BorrowerSeperator.BORROWER && !item.borrowerSeperator),
      //   )
      //   borrowerData[borrowerSeperator].additionalMembers = filteredData
      // })
      await store.dispatch(setBorrowerAllData(setBorrowerDefaultData(borrowerData, loanFieldProperties)))

      // Overview Step Update
      const { auth } = await store.getState()
      // Structure Step
      if (res.process.rateData.rate > 0) {
        overview.structure.detail.rateAndPrice = 1
        overview.structure.detail.lockRate = 0
      }
      if (res.process.rateData.locked) {
        overview.structure.detail.lockRate = 1
        if (getLockExpired({ rateLocked: true, expireDate: res.process.rateData.expireDate })) {
          overview.structure.detail.lockRate = 2
        }
      }
      let overview_structure_status = 1
      Object.keys(overview.structure.detail).map((key) => {
        const detail: any = overview.structure.detail
        if (detail[key] !== 1) {
          overview_structure_status = 0
        }
      })
      overview.structure.status = overview_structure_status

      const anyTimeCanSeeApplicationSubmission = auth.profile.accountType === AccountType.ADMIN

      // Application Step

      // Each Application Steps Logic
      // - Property Info
      application.property = propertyInfoValidate(true) ? 1 : -1
      // - Borrower Info

      const validateStatus: Record<string, number> = {}
      Object.keys(borrowerData).forEach((_borrowerSeparator) => {
        const borrowerSeparator = _borrowerSeparator as any as BorrowerSeperator
        const borrowerKey = borrowerMenuKey(borrowerSeparator, 'borrower')
        validateStatus[borrowerKey] = borrowerInfoValidate(borrowerSeparator, [], {}, true) ? 1 : -1

        const assetKey = borrowerMenuKey(borrowerSeparator, 'asset')
        validateStatus[assetKey] = assetInfoValidate(borrowerSeparator, false) ? 1 : -1

        const trackKey = borrowerMenuKey(borrowerSeparator, 'track')
        validateStatus[trackKey] = trackRecordValidate(
          borrowerSeparator,
          borrowerData[borrowerSeparator].isTrackRecordOverride,
          borrowerData[borrowerSeparator].hasTrackRecord,
          borrowerData[borrowerSeparator].tracks,
        )
          ? 1
          : -1

        const hmdaKey = borrowerMenuKey(borrowerSeparator, 'hmda')
        validateStatus[hmdaKey] = declarationsHmdaValidate(borrowerSeparator, true, false, -1, false) ? 1 : -1

        const creditKey = borrowerMenuKey(borrowerSeparator, 'credit')
        validateStatus[creditKey] = creditValidate(borrowerSeparator, false) ? 1 : -1

        const signKey = borrowerMenuKey(borrowerSeparator, 'sign')
        validateStatus[signKey] = signAppValidate(borrowerSeparator, false) ? 1 : -1

        const additionalMemberKey = borrowerMenuKey(borrowerSeparator, 'additionalMember')
        validateStatus[additionalMemberKey] = additionalMemberValidate(borrowerSeparator) ? 1 : -1

        // Validate custom pages
        Object.keys(loanFieldProperties).forEach((fieldOrigin) => {
          if (isCustomOrigin(fieldOrigin)) {
            const customKey = borrowerMenuKey(borrowerSeparator, fieldOrigin)
            validateStatus[customKey] = customInformationValidate(borrowerSeparator, fieldOrigin, true, false) ? 1 : -1
          }
        })
      })

      application = {
        ...application,
        ...validateStatus,
      }

      application.mlds = signMldsValidate(BorrowerSeperator.BORROWER, false) ? 1 : -1
      // Application Step

      let isCorrespondentLoan = loanData.type == LoanType.CORRESPONDENT

      let applicationDateComplete =
        application.property === 1 &&
        application.borrower === 1 &&
        // application.asset === 1 &&
        application.track === 1 &&
        application.hmda === 1 &&
        application.additionalMember === 1

      // Check custom pages validation for borrower
      Object.keys(loanFieldProperties).forEach((fieldOrigin) => {
        if (isCustomOrigin(fieldOrigin)) {
          const customKey = borrowerMenuKey(BorrowerSeperator.BORROWER, fieldOrigin)
          if (application[customKey] !== 1) {
            applicationDateComplete = false
          }
        }
      })

      let applicationCreditScorePull = application.credit === 1

      let applicationSignApp = application.sign === 1

      if (loanDetailData.includeCoborrower) {
        applicationDateComplete =
          applicationDateComplete &&
          application.borrower2 === 1 &&
          application.hmda2 === 1 &&
          application.asset2 === 1 &&
          application.track2 === 1

        // Check custom pages validation for co-borrower
        Object.keys(loanFieldProperties).forEach((fieldOrigin) => {
          if (isCustomOrigin(fieldOrigin)) {
            const customKey = borrowerMenuKey(BorrowerSeperator.CO_BORROWER, fieldOrigin)
            if (application[customKey] !== 1) {
              applicationDateComplete = false
            }
          }
        })

        applicationCreditScorePull = applicationCreditScorePull && application.credit2 === 1
        applicationSignApp = applicationSignApp && application.sign2 === 1
      }

      overview.application.detail.dataComplete = applicationDateComplete ? 1 : -1
      overview.application.detail.creditScorePull = applicationCreditScorePull ? 1 : -1
      overview.application.detail.signApplication = applicationSignApp ? 1 : -1
      if (isCorrespondentLoan) {
        // overview.application.status = -1
        overview.application.detail.creditScorePull = -2
        // overview.application.detail.signApplication = -2
      }

      if (((loanFieldProperties as any)['visibility'] || {})['sign'] === false)
        delete (overview.application.detail as any).signApplication
      if (((loanFieldProperties as any)['visibility'] || {})['credit'] === false)
        delete (overview.application.detail as any).creditScorePull

      const loanStructureErrors: any = validateLoanStructureData(loanData, loanDetailData.rateData)
      overview.structure.errors = loanStructureErrors

      if (loanStructureErrors.length === 0 || application.credit === 1 || anyTimeCanSeeApplicationSubmission) {
        overview.application.status = checkStatus(overview.application.detail) ? 1 : 0
      }

      await store.dispatch(setApplicationStep(application))

      // Submission Step
      // loanSubmission

      overview.submit.detail.submitToAE = res.workflow.submit_loan.enabled
        ? loanDetailData.submitToAE === 1
          ? 1
          : -1
        : -2
      overview.submit.detail.submitSetup = res.workflow.submit_to_loan_setup.enabled
        ? loanDetailData.submitToLoanSetup === 1
          ? 1
          : -1
        : -2
      overview.submit.detail.conditionSubmit = res.workflow.submit_conditions.enabled
        ? loanDetailData.submitConditions === 1
          ? 1
          : -1
        : -2
      overview.submit.detail.submitUnderwriter = res.workflow.submit_to_underwriter.enabled
        ? loanDetailData.submitToUnderwriter === 1
          ? 1
          : -1
        : -2

      if (loanStructureErrors.length === 0 || anyTimeCanSeeApplicationSubmission) {
        overview.submit.status = checkStatus(overview.submit.detail) ? 1 : 0
      }

      await store.dispatch(setOverviewStep(overview))

      if (menu === 'application') {
        if (overview.application.status === -1) {
          return resolve({
            success: false,
            message: 'Redirect Overview',
          })
        }
      }

      if (menu === 'submit') {
        if (overview.submit.status === -1) {
          return resolve({
            success: false,
            message: 'Redirect Overview',
          })
        }
      }

      resolve({
        success: true,
      })
    } catch (error) {
      console.log('track loanOverviewAndStepLogic Error', error)
      resolve({
        success: false,
        message: 'Redirect Pipeline',
      })
    }
  })
}

export const loanStructureStepUpgrade = async (key: string, status: number) => {
  const { step } = await store.getState()
  let overview = cloneDeep(step.overview)
  overview.structure.detail[key] = status
  if (key === 'rateAndPrice') {
    if (status === 1) {
      overview.structure.detail.lockRate = 0
    }
    if (status === 0) {
      overview.structure.detail.lockRate = -1
    }
  }
  if (key === 'lockRate') {
    if (status === 1) {
      overview.structure.status = 1
    } else {
      overview.structure.status = 0
    }
  }
  await store.dispatch(setOverviewStep(overview))
  return true
}
